import "./Shift.scss";
import React, {useEffect, useState} from "react";
import {Tabs} from "components/common";
import type {TabsProps} from "antd";

import {tabKeys} from "../../../../types/enums";

import {useAppDispatch, useAppSelector} from "redux/hooks";
import DivisionWork from "./components/DivisionWork/DivisionWork";
import ConfigureWorkShifts from "./components/ConfigureWorkShifts/ConfigureWorkShifts";
import {setSiderKey} from "redux/reducer/common";

const Shift = () => {
  const [isDisabled, setIsDisabled] = useState(true);
  const [isDisabledCT, setIsDisabledCT] = useState(true);
  const dispatch = useAppDispatch();
  const activeTab = useAppSelector(state => state.common.activeTab);

  useEffect(() => {
    dispatch(setSiderKey("caLamViec"));
  }, []);

  const items: TabsProps["items"] = [
    {
      key: tabKeys.SHIFT.DIVISION_WORK,
      label: `Phân ca làm việc `,
      children: <DivisionWork />,
    },
    {
      key: tabKeys.SHIFT.CONFIGURE_WORK_SHIFT,
      label: `Cấu hình ca làm việc  `,
      children: <ConfigureWorkShifts />,
    },
  ];
  return (
    <div className="shift page">
      <div className="main">
        <Tabs activeKey={activeTab} items={items} />
      </div>
    </div>
  );
};

export default Shift;
